import { put, takeEvery, call } from "redux-saga/effects";
import { message } from "antd";
import { ERROR_MESSAGE, ENV, YUNPIN_LOCALHOST } from "common/constants";
import { AuthActionTypes } from "./types";
import { fetchLogin } from "./actions";
import { fetchLoading } from "../common/actions";
import { fetchApi } from "utils/fetchApi";
import VhModal from "../../components/vh-common/modal/VhModal";
import Tools from "utils/tools";

/**
 * 登录
 * data:                登录入参
 * changeVerifyCodeFn:  改变图形验证码方法，不论登录结果如何，都变更验证码
 * openSelectCompanyFn: 如果有多家公司，打开公司弹窗，顺便把公司列表和令牌回传，页面拿到公司列表后显示公司弹窗
 * 如果只有一家公司，直接保存信息、关闭登录弹窗
 * 如果没有公司，弹窗并跳转moa加入公司页面
 */
function* handleFetchLogin(action: ReturnType<typeof fetchLogin>) {
  try {
    yield put(fetchLoading({showB: true, text: ""}));
    const { data, changeVerifyCodeFn, openSelectCompanyFn, resultRes } = action.payload;
    
    const res = yield call(fetchApi, "post", `${"hrTrading/login"}`, {...data, hideError: true});
    resultRes(res)
    // const userInfo = {...initAuthState.userInfo};
    let companyList: any[] = [];
    let token = "";
    let userId = "";
    if (res) {
      if (res.result === 0 && Object.keys(res.data).length) {
        if (data.checked) {
          const date = new Date();
          const expiresDays = 7;
          date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000);
          Tools.setCookie("userName", data.userName, date)
          Tools.setCookie("password", data.password, date)
          Tools.setCookie("isRemember", data.checked, date)
        } else {
          Tools.delCookie("userName")
          Tools.delCookie("password")
          Tools.delCookie("isRemember")
        }
        const obj = res.data;
        userId = obj.userId || "";
        companyList = res.data.companyList || [];
        token = res.data.token;
        if (companyList.length) {
          if (companyList.length === 1) {
            // 公司只有一个时直接跳转
            // window.open(`${YUNPIN_LOCALHOST}/main?token=${token}&cid=${companyList[0]?.companyId}`)
            window.location.href = `${YUNPIN_LOCALHOST}/main?token=${token}&cid=${companyList[0]?.companyId}`
            // yield put(fetchModalStatus({showLogin: false}));
          } else if (companyList.length > 1 && openSelectCompanyFn) {
            openSelectCompanyFn(token, companyList, obj);
          }
        } else {
          // VhModal.confirm({
          //   content: "您尚未加入任何公司，请先加入公司",
          //   cancelText: "暂不加入",
          //   okText: "去加入公司",
          //   className: "main-style",
          //   onOk: () => {
          //     window.open(`${YUNPIN_LOCALHOST}/join/${userId}`);
          //   }
          // })
          VhModal.info({
            content: "您尚未加入任何公司，请联系管理员",
            className: "main-style"
          })
        }         
      } else if (res.result !== 0) {
        message.error(res.detail);
      } else {
        message.error("查询错误");
      }
    } else {
      message.error("查询异常");
    }
    if (changeVerifyCodeFn) {
      changeVerifyCodeFn();
    }
  } catch(err) {
    message.error(err instanceof Error ? err.stack! : ERROR_MESSAGE);
  }
  yield put(fetchLoading({showB: false, text: ""}));
}

// 监控，根据指定action类型，调用saga方法
function* authSaga() {
  yield takeEvery(AuthActionTypes.FETCH_LOGIN, handleFetchLogin);
}

export default authSaga;
